export enum Branch {
  Hotfix = 'quick-update',
  Main = 'main',
  Unpublished = 'unpublished',
  Pricing = 'pricing',
  PricingAPI = 'pricing-api',
  SiteDetail = 'site-detail',
  ClientUpdate = 'client-update',
  ClientDisable = 'client-disable',
}
